export default {
    assignments: {
        type: Object,
        default: undefined
    }, 
    autoBind: {
        type: Boolean,
        default: undefined
    }, 
    columnResizeHandleWidth: {
        type: Number,
        default: undefined
    }, 
    columns: {
        type: Array,
        default: undefined
    }, 
    currentTimeMarker: {
        type: [Boolean, Object],
        default: undefined
    }, 
    dataSource: {
        type: [Object, Array],
        default: undefined
    }, 
    date: {
        type: Date,
        default: undefined
    }, 
    dependencies: {
        type: [Object, Array],
        default: undefined
    }, 
    dependenciesDataSourceRef: {
        type: String,
        default: undefined
    },
    editable: {
        type: [Boolean, Object],
        default: undefined
    }, 
    navigatable: {
        type: Boolean,
        default: undefined
    }, 
    workDayStart: {
        type: Date,
        default: undefined
    }, 
    workDayEnd: {
        type: Date,
        default: undefined
    }, 
    workWeekStart: {
        type: Number,
        default: undefined
    }, 
    workWeekEnd: {
        type: Number,
        default: undefined
    }, 
    hourSpan: {
        type: Number,
        default: undefined
    }, 
    snap: {
        type: Boolean,
        default: undefined
    }, 
    height: {
        type: [Number, String],
        default: undefined
    }, 
    listWidth: {
        type: [Number, String],
        default: undefined
    }, 
    messages: {
        type: Object,
        default: undefined
    }, 
    pdf: {
        type: Object,
        default: undefined
    }, 
    range: {
        type: Object,
        default: undefined
    }, 
    resizable: {
        type: Boolean,
        default: undefined
    }, 
    selectable: {
        type: Boolean,
        default: undefined
    }, 
    showWorkDays: {
        type: Boolean,
        default: undefined
    }, 
    showWorkHours: {
        type: Boolean,
        default: undefined
    }, 
    taskTemplate: {
        type: [String, Function],
        default: undefined
    }, 
    toolbar: {
        type: [String, Function, Array],
        default: undefined
    }, 
    tooltip: {
        type: Object,
        default: undefined
    }, 
    views: {
        type: Array,
        default: undefined
    }, 
    resources: {
        type: Object,
        default: undefined
    }, 
    rowHeight: {
        type: [Number, String],
        default: undefined
    }, 

    // Events
    dataBinding: {
        type: Function,
        default: undefined
    },  
    dataBound: {
        type: Function,
        default: undefined
    },  
    add: {
        type: Function,
        default: undefined
    },  
    edit: {
        type: Function,
        default: undefined
    },  
    remove: {
        type: Function,
        default: undefined
    },  
    cancel: {
        type: Function,
        default: undefined
    },  
    save: {
        type: Function,
        default: undefined
    },  
    change: {
        type: Function,
        default: undefined
    },  
    columnResize: {
        type: Function,
        default: undefined
    },  
    navigate: {
        type: Function,
        default: undefined
    },  
    moveStart: {
        type: Function,
        default: undefined
    },  
    move: {
        type: Function,
        default: undefined
    },  
    moveEnd: {
        type: Function,
        default: undefined
    },  
    pdfExport: {
        type: Function,
        default: undefined
    },  
    resizeStart: {
        type: Function,
        default: undefined
    },  
    resize: {
        type: Function,
        default: undefined
    },  
    resizeEnd: Function
}


// WEBPACK FOOTER //
// ./packages/kendo-gantt-vue-wrapper/src/KendoGantt/GanttProps.js